import React from 'react';
import "../MensData.js/ProductsHoodies.css";
import img5 from "../assets/5.jpg" ;

import img6 from "../assets/6.jpg" ;
import img7 from "../assets/7.jpg" ;
import img8 from "../assets/8.jpg" ;
import img9 from "../assets/9.jpg" 
import img10 from "../assets/10.jpg" 
import img11 from "../assets/11.jpg" 
import img12 from "../assets/12.jpg" 
import img13 from "../assets/13.png" 
import img14 from "../assets/14.png" 
import img15 from "../assets/15.png" 
import img16 from "../assets/16.png" 
import img17 from "../assets/17.png" 
import img18 from "../assets/18.png" 
import img19 from "../assets/19.png" 
import img20 from "../assets/20.png" 
import img21 from "../assets/21.png" 
import img22 from "../assets/22.png" 
import img23 from "../assets/23.png" 
import img24 from "../assets/24.png" 
import img25 from "../assets/25.png" 
import img26 from "../assets/26.png" 
import img27 from "../assets/27.png" 
import img28 from "../assets/28.png" 
import img29 from "../assets/29.png" 
import img30 from "../assets/30.png" 
import img31 from "../assets/31.png" 
import img32 from "../assets/32.png" 
import img33 from "../assets/33.png" 
import img34 from "../assets/34.png" 
import img35 from "../assets/35.png" 
import img36 from "../assets/36.png" 
import img37 from "../assets/37.png" 
import img38 from "../assets/38.png" 
import img39 from "../assets/39.png" 
import img40 from "../assets/40.png" 
import img41 from "../assets/41.png" 
import img42 from "../assets/42.png" 
import img43 from "../assets/43.png" 
import img44 from "../assets/44.png" 
import img45 from "../assets/45.png" 
import img46 from "../assets/46.png" 
import img47 from "../assets/47.png" 
import img48 from "../assets/48.png" 
import img49 from "../assets/49.png" 
import img50 from "../assets/50.png" 
import img51 from "../assets/51.png" 
import img52 from "../assets/52.png" 
import img53 from "../assets/53.png" 
import img54 from "../assets/54.png" 
import img55 from "../assets/55.png" 
import img56 from "../assets/56.png" 
import img57 from "../assets/57.png" 
import img58 from "../assets/58.png" 
import img59 from "../assets/59.png" 
import img60 from "../assets/60.png" 
import img61 from "../assets/61.png" 
import img62 from "../assets/62.png" 
import img63 from "../assets/63.png" 
import img64 from "../assets/64.png" 
import img65 from "../assets/65.png" 
import img66 from "../assets/66.png" 
import img67 from "../assets/67.png" 
import img68 from "../assets/68.png" 
import img69 from "../assets/69.png" 
import img70 from "../assets/70.png" 
import img71 from "../assets/71.png" 
import img72 from "../assets/72.png" 
import img73 from "../assets/73.png" 
import img74 from "../assets/74.png" 
import img75 from "../assets/75.png" 
import img76 from "../assets/76.png" 
import img77 from "../assets/77.png" 
import img78 from "../assets/78.png" 
import img79 from "../assets/79.png" 
import img80 from "../assets/80.png" 
import img81 from "../assets/81.png" 
import img82 from "../assets/82.png" 
import img83 from "../assets/83.png" 
export default function ProductsHoodies() {

  const productsHoodie = [
    {
      id: 1,
      name: "Model No. MG-25725-16",
      description: "Premium leather, modern fit, soft inner lining.",
      image: img5,
      link: "/products/mens-sweat-top&hoodie20",
    },
    {
      id: 2,
      name: "Model No. MG-25725-20",
      description: "Classic blue denim for everyday casual styling.",
      image: img6,
      link: "/products/mens-sweat-top&hoodie21",
    },
     {
      id: 3,
      name: "Model No. MG-25725-21",
      description: "Classic blue denim for everyday casual styling.",
      image: img7,
      link: "/products/mens-sweat-top&hoodie22",
    },
     {
      id: 4,
      name: "Model No. MG-25725-22",
      description: "Classic blue denim for everyday casual styling.",
      image: img8,
      link: "/products/mens-sweat-top&hoodie23",
    },
     {
      id: 5,
      name: "Model No. MG-25725-23",
      description: "Classic blue denim for everyday casual styling.",
      image: img9,
      link: "/products/mens-sweat-top&hoodie25",
    },
     {
      id: 6,
      name: "Model No. MG-25725-24",
      description: "Classic blue denim for everyday casual styling.",
      image: img10,
      link: "/products/mens-sweat-top&hoodie26",
    },
   
    {
      id: 7,
      name: "Model No. MG-25725-25",
      description: "Classic blue denim for everyday casual styling.",
      image: img11,
      link: "/products/mens-sweat-top&hoodie29",
    },
  
    {
      id: 8,
      name: "Model No. MG-25725-26",
      description: "Classic blue denim for everyday casual styling.",
      image: img12,
      link: "/products/mens-sweat-top&hoodie30",
    },
  
    {
      id: 9,
      name: "Model No. MG-25725-27",
      description: "Classic blue denim for everyday casual styling.",
      image:img13,
      link: "/products/mens-sweat-top&hoodie31",
    },
  
    {
      id: 10,
      name: "Model No. MG-25725-28",
      description: "Classic blue denim for everyday casual styling.",
      image: img14,
      link: "/products/mens-sweat-top&hoodie32",
    },
  
    {
      id: 11,
      name: "Model No. MG-25725-29",
      description: "Classic blue denim for everyday casual styling.",
      image: img15,
      link: "/products/mens-sweat-top&hoodie33",
    },
  
    {
      id: 12,
      name: "Model No. MG-25725-30",
      description: "Classic blue denim for everyday casual styling.",
      image: img16,
      link: "/products/mens-sweat-top&hoodie34",
    },
  
     {
      id: 13,
      name: "Model No. MG-25725-31",
      description: "Classic blue denim for everyday casual styling.",
      image: img17,
      link: "/products/mens-sweat-top&hoodie35",
    },
  
     {
      id: 14,
      name: "Model No. MG-25725-32",
      description: "Classic blue denim for everyday casual styling.",
      image: img18,
      link: "/products/mens-sweat-top&hoodie36",
    },
  
     {
      id: 15,
      name: "Model No. MG-25725-33",
      description: "Classic blue denim for everyday casual styling.",
      image: img19,
      link: "/products/mens-sweat-top&hoodie37",
    },
  
      {
      id: 16,
      name: "Model No. MG-25725-34",
      description: "Classic blue denim for everyday casual styling.",
      image: img20,
      link: "/products/mens-sweat-top&hoodie38",
    },
  
      {
      id: 17,
      name: "Model No. MG-25725-35",
      description: "Classic blue denim for everyday casual styling.",
      image: img21,
      link: "/products/mens-sweat-top&hoodie39",
    },
  
      {
      id: 18,
      name: "Model No. MG-25725-36",
      description: "Classic blue denim for everyday casual styling.",
      image: img22,
      link: "/products/mens-sweat-top&hoodie40",
    },
  
     {
      id: 19,
      name: "Model No. MG-25725-37",
      description: "Classic blue denim for everyday casual styling.",
      image:img23,
      link: "/products/mens-sweat-top&hoodie41",
    },
  
     {
      id: 20,
      name: "Model No. MG-25725-38",
      description: "Classic blue denim for everyday casual styling.",
      image: img24,
      link: "/products/mens-sweat-top&hoodie42",
    },
  
     {
      id: 21,
      name: "Model No. MG-25725-39",
      description: "Classic blue denim for everyday casual styling.",
      image: img25,
      link: "/products/mens-sweat-top&hoodie43",
    },
  
    {
      id: 22,
      name: "Model No. MG-25725-40",
      description: "Classic blue denim for everyday casual styling.",
      image: img26,
      link: "/products/mens-sweat-top&hoodie44",
    },
    {
      id: 23,
      name: "Model No. MG-25725-41",
      description: "Classic blue denim for everyday casual styling.",
      image: img27,
      link: "/products/mens-sweat-top&hoodie45",
    },
  
    {
      id: 24,
      name: "Model No. MG-25725-42",
      description: "Classic blue denim for everyday casual styling.",
      image: img28,
      link: "/products/mens-sweat-top&hoodie46",
    },
      
      {
      id: 26,
      name: "Model No. MG-25725-44",
      description: "Classic blue denim for everyday casual styling.",
      image: img30,
      link: "/products/mens-sweat-top&hoodie47",
    },
      {
      id: 27,
      name: "Model No. MG-25725-45",
      description: "Classic blue denim for everyday casual styling.",
      image: img31,
      link: "/products/mens-sweat-top&hoodie48",
    },
  
     {
      id: 28,
      name: "Model No. MG-25725-46",
      description: "Classic blue denim for everyday casual styling.",
      image: img32,
      link: "/products/mens-sweat-top&hoodie49",
    },
     {
      id: 29,
      name: "Model No. MG-25725-47",
      description: "Classic blue denim for everyday casual styling.",
      image: img33,
      link: "/products/mens-sweat-top&hoodie50",
    },
     {
      id: 30,
      name: "Model No. MG-25725-48",
      description: "Classic blue denim for everyday casual styling.",
      image: img34,
      link: "/products/mens-sweat-top&hoodie51",
    },
  
     {
      id: 31,
      name: "Model No. MG-25725-49",
      description: "Classic blue denim for everyday casual styling.",
      image: img35,
      link: "/products/mens-sweat-top&hoodie52",
    },
     {
      id: 32,
      name: "Model No. MG-25725-50",
      description: "Classic blue denim for everyday casual styling.",
      image: img36,
      link: "/products/mens-sweat-top&hoodie53",
    },
     {
      id: 33,
      name: "Model No. MG-25725-51",
      description: "Classic blue denim for everyday casual styling.",
      image:img37,
      link: "/products/mens-sweat-top&hoodie54",
    },
      {
      id: 34,
      name: "Model No. MG-25725-52",
      description: "Classic blue denim for everyday casual styling.",
      image: img38,
      link: "/products/mens-sweat-top&hoodie55",
    },
      {
      id: 35,
      name: "Model No. MG-25725-53",
      description: "Classic blue denim for everyday casual styling.",
      image: img39,
      link: "/products/mens-sweat-top&hoodie56",
    },
      {
      id: 36,
      name: "Model No. MG-25725-54",
      description: "Classic blue denim for everyday casual styling.",
      image: img40,
      link: "/products/mens-sweat-top&hoodie57",
    },
  
      {
      id: 37,
      name: "Model No. MG-25725-55",
      description: "Classic blue denim for everyday casual styling.",
      image: img41,
      link: "/products/mens-sweat-top&hoodie58",
    },
      {
      id: 38,
      name: "Model No. MG-25725-56",
      description: "Classic blue denim for everyday casual styling.",
      image:img42,
      link: "/products/mens-sweat-top&hoodie59",
    },
      {
      id: 39,
      name: "Model No. MG-25725-57",
      description: "Classic blue denim for everyday casual styling.",
      image: img43,
      link: "/products/mens-sweat-top&hoodie60",
    },
  
    {
      id: 40,
      name: "Model No. MG-25725-58",
      description: "Classic blue denim for everyday casual styling.",
      image: img44,
      link: "/products/mens-sweat-top&hoodie61",
    },
  
    {
      id: 42,
      name: "Model No. MG-25725-60",
      description: "Classic blue denim for everyday casual styling.",
      image: img45,
      link: "/products/mens-sweat-top&hoodie62",
    },
   
    
    {
      id: 43,
      name: "Model No. MG-25725-61",
      description: "Classic blue denim for everyday casual styling.",
      image: img46,
      link: "/products/mens-sweat-top&hoodie63",
    },
    
    {
      id: 44,
      name: "Model No. MG-25725-62",
      description: "Classic blue denim for everyday casual styling.",
      image: img47,
      link: "/products/mens-sweat-top&hoodie64",
    },
    
    {
      id: 45,
      name: "Model No. MG-25725-63",
      description: "Classic blue denim for everyday casual styling.",
      image: img48,
      link: "/products/mens-sweat-top&hoodie65",
    },
  
  
      {
      id: 46,
      name: "Model No. MG-25725-64",
      description: "Classic blue denim for everyday casual styling.",
      image: img49,
      link: "/products/mens-sweat-top&hoodie66",
    },
      {
      id: 47,
      name: "Model No. MG-25725-65",
      description: "Classic blue denim for everyday casual styling.",
      image: img50,
      link: "/products/mens-sweat-top&hoodie67",
    },
      {
      id: 48,
      name: "Model No. MG-25725-66",
      description: "Classic blue denim for everyday casual styling.",
      image: img51,
      link: "/products/mens-sweat-top&hoodie68",
    },
    {
      id: 49,
      name: "Model No. MG-25725-67",
      description: "Classic blue denim for everyday casual styling.",
      image: img52,
      link: "/products/mens-sweat-top&hoodie69",
    },
    {
      id: 50,
      name: "Model No. MG-25725-68",
      description: "Classic blue denim for everyday casual styling.",
      image: img53,
      link: "/products/mens-sweat-top&hoodie70",
    },
    {
      id: 51,
      name: "Model No. MG-25725-69",
      description: "Classic blue denim for everyday casual styling.",
      image: img54,
      link: "/products/mens-sweat-top&hoodie71",
    },
  
     {
      id: 52,
      name: "Model No. MG-25725-70",
      description: "Classic blue denim for everyday casual styling.",
      image: img55,
      link: "/products/mens-sweat-top&hoodie72",
    },
   {
      id: 53,
      name: "Model No. MG-25725-71",
      description: "Classic blue denim for everyday casual styling.",
      image: img56,
      link: "/products/mens-sweat-top&hoodie73",
    },
   {
      id: 54,
      name: "Model No. MG-25725-72",
      description: "Classic blue denim for everyday casual styling.",
      image: img57,
      link: "/products/mens-sweat-top&hoodie74",
    },
  
     {
      id: 55,
      name: "Model No. MG-25725-73",
      description: "Classic blue denim for everyday casual styling.",
      image: img58,
      link: "/products/mens-sweat-top&hoodie75",
    },
     {
      id: 56,
      name: "Model No. MG-25725-74",
      description: "Classic blue denim for everyday casual styling.",
      image: img59,
      link: "/products/mens-sweat-top&hoodie75",
    },
     {
      id: 57,
      name: "Model No. MG-25725-75",
      description: "Classic blue denim for everyday casual styling.",
      image: img60,
      link: "/products/mens-sweat-top&hoodie76",
    },
    {
      id: 58,
      name: "Model No. MG-25725-76",
      description: "Classic blue denim for everyday casual styling.",
      image: img61,
      link: "/products/mens-sweat-top&hoodie77",
    },
     {
      id: 59,
      name: "Model No. MG-25725-77",
      description: "Classic blue denim for everyday casual styling.",
      image: img62,
      link: "/products/mens-sweat-top&hoodie78",
    },
     {
      id: 60,
      name: "Model No. MG-25725-78",
      description: "Classic blue denim for everyday casual styling.",
      image: img63,
      link: "/products/mens-sweat-top&hoodie79",
    },
       {
      id: 61,
      name: "Model No. MG-25725-79",
      description: "Classic blue denim for everyday casual styling.",
      image: img64,
      link: "/products/mens-sweat-top&hoodie80",
    },
       {
      id: 62,
      name: "Model No. MG-25725-80",
      description: "Classic blue denim for everyday casual styling.",
      image: img65,
      link: "/products/mens-sweat-top&hoodie81",
    },
       {
      id: 63,
      name: "Model No. MG-25725-81",
      description: "Classic blue denim for everyday casual styling.",
      image: img66,
      link: "/products/mens-sweat-top&hoodie82",
    },
     {
      id: 64,
      name: "Model No. MG-25725-82",
      description: "Classic blue denim for everyday casual styling.",
      image: img67,
      link: "/products/mens-sweat-top&hoodie1",
    },
     {
      id: 65,
      name: "Model No. MG-25725-83",
      description: "Classic blue denim for everyday casual styling.",
      image: img68,
      link: "/products/mens-sweat-top&hoodie2",
    },
     {
      id: 66,
      name: "Model No. MG-25725-84",
      description: "Classic blue denim for everyday casual styling.",
      image: img69,
      link: "/products/mens-sweat-top&hoodie3",
    },
  
      {
      id: 67,
      name: "Model No. MG-25725-85",
      description: "Classic blue denim for everyday casual styling.",
      image: img70,
      link: "/products/mens-sweat-top&hoodie4",
    },
      {
      id: 68,
      name: "Model No. MG-25725-86",
      description: "Classic blue denim for everyday casual styling.",
      image: img71,
      link: "/products/mens-sweat-top&hoodie5",
    },
      {
      id: 69,
      name: "Model No. MG-25725-87",
      description: "Classic blue denim for everyday casual styling.",
      image: img72,
      link: "/products/mens-sweat-top&hoodie6",
    },
      {
      id: 70,
      name: "Model No. MG-25725-88",
      description: "Classic blue denim for everyday casual styling.",
      image: img73,
      link: "/products/mens-sweat-top&hoodie7",
    },
      {
      id: 71,
      name: "Model No. MG-25725-89",
      description: "Classic blue denim for everyday casual styling.",
      image: img74,
      link: "/products/mens-sweat-top&hoodie8",
    },
      {
      id: 72,
      name: "Model No. MG-25725-90",
      description: "Classic blue denim for everyday casual styling.",
      image: img75,
      link: "/products/mens-sweat-top&hoodie9",
    },
     {
      id: 73,
      name: "Model No. MG-25725-91",
      description: "Classic blue denim for everyday casual styling.",
      image: img76,
      link: "/products/mens-sweat-top&hoodie10",
    },
     {
      id: 74,
      name: "Model No. MG-25725-92",
      description: "Classic blue denim for everyday casual styling.",
      image: img77,
      link: "/products/mens-sweat-top&hoodie11",
    },
     {
      id: 75,
      name: "Model No. MG-25725-93",
      description: "Classic blue denim for everyday casual styling.",
      image: img78,
      link: "/products/mens-sweat-top&hoodie12",
    },
    {
      id: 76,
      name: "Model No. MG-25725-94",
      description: "Classic blue denim for everyday casual styling.",
      image: img79,
      link: "/products/mens-sweat-top&hoodie13",
    },
    {
      id: 77,
      name: "Model No. MG-25725-95",
      description: "Classic blue denim for everyday casual styling.",
      image: img80,
      link: "/products/mens-sweat-top&hoodie14",
    },
    {
      id: 78,
      name: "Model No. MG-25725-96",
      description: "Classic blue denim for everyday casual styling.",
      image: img81,
      link: "/products/mens-sweat-top&hoodie15",
    },
     {
      id: 79,
      name: "Model No. MG-25725-97",
      description: "Classic blue denim for everyday casual styling.",
      image: img82,
      link: "/products/mens-sweat-top&hoodie16",
    },
     {
      id: 80,
      name: "Model No. MG-25725-98",
      description: "Classic blue denim for everyday casual styling.",
      image: img83,
      link: "/products/mens-sweat-top&hoodie17",
    },
  ];
  
  return (
    <>
       <section className="ph">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men’s Sweat Top & Hoodie</h1>
      <div className="pj__grid">
        {productsHoodie.map((p) => (
          <article key={p.id} className="ph__card">
            <img className="ph__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="ph__name">{p.name}</h3>
            {/* <p className="ph__desc">{p.description}</p> */}
            <a className="ph__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
